import { FC } from "react";
import { IconPropsType } from ".";

export const Setting: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.0928 5.9613L12.9995 3.0207C12.0713 2.4848 10.9277 2.4848 9.99952 3.0207L4.90625 5.9613C3.97805 6.4972 3.40625 7.48758 3.40625 8.55937V14.4406C3.40625 15.5124 3.97805 16.5027 4.90625 17.0386L9.99952 19.9792C10.9277 20.5151 12.0713 20.5151 12.9995 19.9792L18.0928 17.0386C19.021 16.5027 19.5928 15.5124 19.5928 14.4406V8.55937C19.5928 7.48758 19.021 6.4972 18.0928 5.9613ZM13.4995 2.15467C12.2619 1.44014 10.7371 1.44014 9.49952 2.15467L4.40625 5.09527C3.16865 5.8098 2.40625 7.13031 2.40625 8.55937V14.4406C2.40625 15.8696 3.16865 17.1901 4.40625 17.9047L9.49952 20.8453C10.7371 21.5598 12.2619 21.5598 13.4995 20.8453L18.5928 17.9047C19.8304 17.1901 20.5928 15.8696 20.5928 14.4406V8.55937C20.5928 7.13031 19.8304 5.8098 18.5928 5.09527L13.4995 2.15467Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5 15C13.433 15 15 13.433 15 11.5C15 9.567 13.433 8 11.5 8C9.567 8 8 9.567 8 11.5C8 13.433 9.567 15 11.5 15ZM11.5 16C13.9853 16 16 13.9853 16 11.5C16 9.01472 13.9853 7 11.5 7C9.01472 7 7 9.01472 7 11.5C7 13.9853 9.01472 16 11.5 16Z"
        fill={props.color}
      />
    </svg>
  );
};
